import React from "react";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerEntities } from "../JobArrangerEntities";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { JobStatusObject } from "../JobStatusObject";

interface JobListPageProps extends NSARouterMakerProps, JobArrangerProps { }

export default class JobListPage extends React.Component<JobListPageProps>
{
	override render()
	{
		return (
			<JobArrangerLayout
				{...this.props}
				action={{
					title: "",
					description: "List of all the jobs you've added through the extension.",
					menus: {}
				}}
				pages={{
					entity: JobArrangerEntities.job(this.props),
					list: {
						ui: {
							getRowAttributes(row_value)
							{
								let backgroundColor = JobStatusObject.get(row_value.status)?.color;
								return { style: { "background-color": backgroundColor } };
							},
						}
					}
				}}
			>
				<></>
			</JobArrangerLayout >
		);
	}
}